import React, { useState } from "react";
import toast from "react-hot-toast";
import { api } from "../../utils/axios-instance";

const ResendInvites = ({ close }) => {
  const [loading, setLoading] = useState(false);

  const handleResend = async () => {
    setLoading(true);
    try {
      const res = await api.post("/invites/resend");

      if (res.status === 200) {
        toast.success(`Resent ${res.data.resent || 0} invites`);
        close();
      } else {
        throw new Error("Failed to resend invites");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to resend invites");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      onClick={handleResend}
      className="w-[140px] h-[120px] py-4 px-3 rounded-lg border bg-[#f7f7ff] flex flex-col items-center justify-center gap-2 hover:bg-indigo-100 text-center cursor-pointer"
    >
      <img
        src={`${process.env.PUBLIC_URL}/assets/InviteMember.webp`}
        alt="resend invites"
        className="h-8 w-8 object-contain"
      />
      <p className="text-sm font-medium leading-tight">
        {loading ? "Processing..." : "Resend Expired Invites"}
      </p>
    </div>
  );
};

export default ResendInvites;